import actions from './priceListActions';
import mutations from './priceListMutations';

const state = {
  items: [],
  current: null
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/pricelist/index.js